import { execOnLoad } from '@general/helpers';
import { closeModal, openModal } from '@components/modals';
import './newsletter.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initNewsletterForm = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const submit = sectionContainer.querySelector('[type="submit"]');
  sectionContainer.querySelectorAll('input').forEach((input) => {
    const formElement = input.closest('.form-element');
    if (!formElement) return;

    input.addEventListener('invalid', (e) => {
      e.preventDefault();
      formElement.classList.add('error');
      input.setAttribute('aria-invalid', 'true');
      if (submit) submit.disabled = true;
    });

    input.addEventListener('change', () => {
      formElement.classList.remove('error');
      input.removeAttribute('aria-invalid');
      const errorElements = sectionContainer.querySelectorAll(
        '.form-element.error',
      ).length;
      if (submit && errorElements === 0) submit.disabled = false;
    });
  });

  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const subscribed = params.get('customer_posted');
  if (subscribed) {
    const newsletterModal = document.querySelector(
      "[data-trigger-id='footerNewsletterSubmit']",
    );
    openModal(`#${newsletterModal.id}`, false);
    setTimeout(() => {
      closeModal(`#${newsletterModal.id}`, false);
      document.querySelector('.newsletter__form-success').style.display =
        'none';
    }, 3000);
  }
};

execOnLoad(window.dAgency.initNewsletterForm, '.newsletter__container');
